import type { SemanticResult } from './searchTypes';

interface SemanticResponse {
  results?: SemanticResult[];
  error?: string | { code?: string; message?: string };
  message?: string;
}

export class SemanticSearchError extends Error {
  constructor(
    message: string,
    readonly code: string,
  ) {
    super(message);
  }
}

export async function requestSemanticResults(
  query: string,
  conferenceId: string,
  signal?: AbortSignal,
): Promise<SemanticResult[]> {
  const response = await fetch('/api/v2/search/semantic', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ query, conferenceId, limit: 50 }),
    signal,
  });
  const payload = (await response.json().catch(() => ({}))) as SemanticResponse;
  if (!response.ok || !payload.results) {
    const error = typeof payload.error === 'object' ? payload.error : undefined;
    throw new SemanticSearchError(
      error?.message ?? payload.message ?? 'Semantic ranking is unavailable.',
      error?.code ??
        (response.status === 401
          ? 'AUTH_REQUIRED'
          : response.status === 403 && payload.error === 'ai_access_denied'
            ? 'AI_ACCESS_DENIED'
          : response.status === 429
            ? 'AI_SEARCH_DAILY_LIMIT_REACHED'
            : 'SEARCH_SEMANTIC_UNAVAILABLE'),
    );
  }
  return payload.results;
}

